import { createFileRoute } from "@tanstack/react-router";
import { BackLink } from "@/ui";
import { SubscriberDetail } from "#/components/subscribers/SubscriberDetail";

// One subscriber (#643 follow-up). Replaces the per-row "View history" modal:
// a modal cannot be linked to, cannot be opened in a new tab, and had nowhere
// to put the fields the list row used to carry alongside a 200-entry timeline.
//
// Two params, matching the row's primary key. TanStack Router encodes and
// decodes them, so `@` and a `+tag` address survive the round trip without
// call-site `encodeURIComponent` — and an address containing `/` cannot occur,
// since `getSubscriberHistory`'s input is `z.email()`.
export const Route = createFileRoute(
  "/dashboard/w/$workspaceId/subscribers/$domain/$email",
)({
  component: SubscriberPage,
});

function SubscriberPage() {
  const { workspaceId, domain, email } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      {/*
        A destination, not `history.back()`: a subscriber is reachable from the
        list, from a bookmark and from a shared link, and only a fixed
        destination is the same for all three. See `BackLink`.
      */}
      <BackLink
        to="/dashboard/w/$workspaceId/subscribers"
        params={{ workspaceId }}
      >
        Subscribers
      </BackLink>

      <SubscriberDetail
        workspaceId={workspaceId}
        domain={domain}
        email={email}
      />
    </div>
  );
}
